import { render, staticRenderFns } from "./Recordatorios.vue?vue&type=template&id=76c8509d&scoped=true"
import script from "./Recordatorios.vue?vue&type=script&lang=js"
export * from "./Recordatorios.vue?vue&type=script&lang=js"
import style0 from "./Recordatorios.vue?vue&type=style&index=0&id=76c8509d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c8509d",
  null
  
)

export default component.exports